import React, { useContext, useLayoutEffect, useState } from "react";
import { DataContext } from "../../index";
import BBP_POD from "../../../assest/images/BBP-POD.webp";
import BBP_POD_1 from "../../../assest/images/BBP-EBISBN-001.webp";
import PTR200 from "../../../assest/images/PTR200-PRINT-BB.webp";
import BOOK_ from "../../../assest/images/BOOK_.webp";
import "../../index.css";

export const MainSection = () => {
  const counterState = useContext(DataContext);

  const [isClicked, setIsClicked] = useState(false);
   const [prevClicked, setPrevClicked]= useState(false);
    const [queryValue, setQueryValue]=useState("");
  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => {
      setIsClicked(false);
    }, 500); // Duration of the animation in milliseconds
  };


  const handleClickFunc = () => {
    setPrevClicked(true);
    setTimeout(() => {
      setPrevClicked(false);
    },500); // Duration of the animation in milliseconds
  };





  let {
    sidebarData,
    liData,
    getLiData,
    selectValue,
    setSelectValue,
    onChangeAllValue,
    onSectionTwo,
    onSectionThree,
    onSectionFour,
    onSectionFive,
    onSectionSix,
    onOpenModal,
    sidebarLink,
    onSectionSeven,
    onSectionEight,
    displayedSidebar
  } = counterState;

  console.log("displayedSidebar",displayedSidebar);


  useLayoutEffect(() =>{
    const queryParams = new URLSearchParams(window.location.search);

    // Get the values of the specific parameters
    const projectType = queryParams.get('projectType');
    setQueryValue(projectType);


  },[]);



  return (
    <div className="w-full">
      <div class="col-md-7 p-0">
        <div class="cal-step-conttent">
          <div class="tab-content">
            {queryValue == "printedbooks" ? (
                   liData == 1 ? (
                    <>
                      <div class="tab-pane fade show active" id="stepNew1">
                        <form id="stepForm">
                          <div class="Cal-Form-one">
                            <div class="container p-0">
                              <div class="row flex justify-between w-full">
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont">
                                    <h2>Do you need book distribution?</h2>
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input !text-[#c65300]"
                                        type="radio"
                                        checked={selectValue.section1 === "399"}
                                        onChange={onChangeAllValue}
                                        name="section1"
                                        value="399"
                                        id="first-check-one"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="first-check-one"
                                      >
                                        Printed on Demand (Global Retailers) ($399)
                                      </label>
                                    </div>
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input !text-[#c65300]"
                                        onChange={onChangeAllValue}
                                        checked={selectValue.section1 === "149"}
                                        type="radio"
                                        name="section1"
                                        id="first-check-two"
                                        value="149"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="first-check-two"
                                      >
                                        Print On Demand (Bookshop™ Only) ($149)
                                      </label>
                                    </div>
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input !text-[#c65300]"
                                        onChange={onChangeAllValue}
                                        checked={selectValue.section1 === "0"}
                                        type="radio"
                                        id="first-check-Three"
                                        name="section1"
                                        value="0"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="first-check-Three"
                                      >
                                        I don't need printed book distribution
                                      </label>
                                    </div>
                                  </div>
                                </div>
      
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                    <figure className="flex flex-col justify-center items-center">
                                      <img src={BBP_POD} class="img-fluid" alt="" />
                                    </figure>
                                    <p>
                                      Make your book available for sale with the
                                      largest network of global booksellers,
                                      libraries, and online retailers. Includes
                                      distribution to Amazon, Powell’s, Barnes &
                                      Noble, Ingram, Baker & Taylor, and 50+ others.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="row m-0">
                                <div class="col-md-12 p-0">
                                  <div class="form-button-step">
                                    <button
                                      type="button"
                                      // class="btn themeBtn"
                                      // disabled
                                      onClick={handleClickFunc}
                                        // onClick={() => getLiData(2)}
                                        className={
                                          prevClicked
                                            ? "jerk-button btn themeBtn"
                                            : "btn themeBtn"
                                        }
                                    >
                                      Previous
                                    </button>
                                    {selectValue.section1 == null ? (
                                      <button
                                        type="button"
                                        // class="btn themeBtn"
                                        // disabled={selectValue.section1 == null}
                                        onClick={handleClick}
                                        // onClick={() => getLiData(2)}
                                        className={
                                          isClicked
                                            ? "jerk-button btn themeBtn opacity-35"
                                            : "btn themeBtn opacity-35"
                                        }
                                      >
                                        Next
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        class="btn themeBtn"
                                        disabled={selectValue.section1 == null}
                                        onClick={() => getLiData(2)}
                                      >
                                        Next
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
      
                      {/* <button onClick={() => setSelectValue("section1")}>
                  Select Section One
                </button> */}
                      {/* <button
                  disabled={selectValue == ""}
                  onClick={() => getLiData(2)}
                  className="bg-black text-white"
                >
                  Next
                </button> */}
                    </>
                  ) : liData == 2 ? (
                    <>
                      <div class="tab-pane fade" id="stepNew2">
                        <form id="stepForm">
                          <div class="Cal-Form-one">
                            <div class="container p-0">
                              <div class="row flex justify-between w-full">
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont">
                                    <h2>Do you need text formatting?</h2>
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        value="100"
                                        name="section2"
                                        onChange={onSectionTwo}
                                        checked={selectValue.section2 == "100"}
                                        id="second-check-one"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="second-check-one"
                                      >
                                        I need text formatting
                                      </label>
                                    </div>
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="section2"
                                        value="200"
                                        onChange={onSectionTwo}
                                        checked={selectValue.section2 == "200"}
                                        id="second-check-two"
                                        //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                      />
                                      <label
                                        class="form-check-label"
                                        for={"second-check-two"}
                                      >
                                        I didn't need text formatting
                                      </label>
                                    </div>
      
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="section2"
                                        onChange={onSectionTwo}
                                        checked={selectValue.section2 == "300"}
                                        value="300"
                                        id="second-check-three"
                                        //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                      />
                                      <label
                                        class="form-check-label"
                                        for={"second-check-three"}
                                      >
                                        I didn't need text formatting
                                      </label>
                                    </div>
      
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="section2"
                                        value="400"
                                        onChange={onSectionTwo}
                                        checked={selectValue.section2 == "400"}
                                        id="second-check-four"
                                        //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="second-check-four"
                                      >
                                        I didn't need text formatting
                                      </label>
                                    </div>
      
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="section2"
                                        value="500"
                                        onChange={onSectionTwo}
                                        checked={selectValue.section2 == "500"}
                                        id="second-check-five"
                                        //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="second-check-five"
                                      >
                                        I didn't need text formatting
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont flex justify-center flex-col items-center">
                                    <figure class="flex justify-center flex-col items-center">
                                      <img
                                        src={BBP_POD}
                                        class="img-fluid !w-4/5"
                                        alt=""
                                      />
                                    </figure>
                                    <p>
                                      Make your book available for sale with the
                                      largest network of global booksellers,
                                      libraries, and online retailers. Includes
                                      distribution to Amazon, Powell’s, Barnes &
                                      Noble, Ingram, Baker & Taylor, and 50+ others.
                                    </p>
                                  </div>
                                </div>
                              </div>
      
                              <div class="row m-0">
                                <div class="col-md-12 p-0">
                                  <div class="form-button-step">
                                    <button
                                      type="button"
                                      onClick={() => getLiData(1)}
                                      class="btn themeBtn"
                                    >
                                      Previous
                                    </button>
                                    {selectValue.section2 == null ? (
                                      <button
                                        type="button"
                                        // disabled={selectValue.section2 == null}
                                        // class="btn themeBtn"
                                        onClick={handleClick}
                                        className={
                                          isClicked
                                            ? "jerk-button btn themeBtn opacity-35"
                                            : "btn themeBtn opacity-35"
                                        }
                                      >
                                        Next
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        disabled={selectValue.section2 == null}
                                        onClick={() => getLiData(3)}
                                        class="btn themeBtn"
                                      >
                                        Next
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
      
                      {/* <button onClick={() => setSelectValue("section2")}>
                        Select Section Two
                      </button>
                      <button
                        disabled={selectValue == ""}
                        onClick={() => getLiData(3)}
                        className="bg-black text-white"
                      >
                        Next
                      </button> */}
                    </>
                  ) : liData == 3 ? (
                    <>
                      <div class="tab-pane fade" id="stepNew3">
                        <form id="stepForm">
                          <div class="Cal-Form-one">
                            <div class="container p-0">
                              <div class="row flex justify-between w-full">
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont">
                                    <h2>Do you need cover design?</h2>
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input "
                                        type="radio"
                                        id="first-check-three-one"
                                        value="599"
                                        onChange={onSectionThree}
                                        checked={selectValue.section3 == "599"}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="first-check-three-one"
                                      >
                                        Professional Cover Design ($599)
                                      </label>
                                    </div>
                                    <div class="form-check p-2">
                                      <input
                                        class="form-check-input "
                                        type="radio"
                                        id="first-check-three-Two"
                                        value="50"
                                        onChange={onSectionThree}
                                        checked={selectValue.section3 == "50"}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="first-check-three-Two"
                                      >
                                        I am supplying my cover design
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont  flex justify-center flex-col items-center">
                                    <figure className=" flex justify-center items-center">
                                      <img src={BBP_POD} class="img-fluid" alt="" />
                                    </figure>
                                    <p>
                                      Make your book available for sale with the
                                      largest network of global booksellers,
                                      libraries, and online retailers. Includes
                                      distribution to Amazon, Powell’s, Barnes &
                                      Noble, Ingram, Baker & Taylor, and 50+ others.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="row m-0">
                                <div class="col-md-12 p-0">
                                  <div class="form-button-step">
                                    <button
                                      type="button"
                                      onClick={() => getLiData(2)}
                                      class="btn themeBtn"
                                    >
                                      Previous
                                    </button>
                                    {selectValue.section3 == null ? (
                                      <button
                                        type="button"
                                        // disabled={selectValue.section3 == null}
                                        // onClick={() => getLiData(4)}
                                        // class="btn themeBtn"
                                        onClick={handleClick}
                                        // onClick={() => getLiData(2)}
                                        className={
                                          isClicked
                                            ? "jerk-button btn themeBtn opacity-35"
                                            : "btn themeBtn opacity-35"
                                        }
                                      >
                                        Next
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        disabled={selectValue.section3 == null}
                                        onClick={() => getLiData(4)}
                                        class="btn themeBtn"
                                      >
                                        Next
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
      
                      {/* <button onClick={() => setSelectValue("section3")}>
                        Select Section 3
                      </button>
                      <button
                        disabled={selectValue == ""}
                        onClick={() => getLiData(4)}
                        className="bg-black text-white"
                      >
                        Next
                      </button> */}
                    </>
                  ) : liData == 4 ? (
                    <>
                      <div class="tab-pane fade" id="stepNew4">
                        <form id="stepForm">
                          <div class="Cal-Form-one">
                            <div class="container p-0">
                              <div class="row flex justify-between items-center w-full">
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont">
                                    <h2>Do you need an ISBN?</h2>
                                    <div class="form-check px-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="first-check-four-one"
                                        name="section4"
                                        onChange={onSectionFour}
                                        checked={selectValue.section4 == "49"}
                                        value="49"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="first-check-four-one"
                                      >
                                        I need to purchase an ISBN number ($49)
                                      </label>
                                    </div>
                                    <div class="form-check px-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="first-check-four-Two"
                                        name="section4"
                                        onChange={onSectionFour}
                                        checked={selectValue.section4 == "99"}
                                        value="99"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="first-check-four-Two"
                                      >
                                        I already have an ISBN for my book
                                      </label>
                                    </div>
                                    <div class="form-check px-2">
                                      <input
                                        class="form-check-input "
                                        type="radio"
                                        id="first-check-four-three"
                                        name="section4"
                                        onChange={onSectionFour}
                                        checked={selectValue.section4 == "149"}
                                        value="149"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="first-check-four-three"
                                      >
                                        I don't need an ISBN number
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont">
                                    <figure className="flex justify-center items-center">
                                      <img src={BBP_POD_1} class="img-fluid" alt="" />
                                    </figure>
                                  </div>
                                </div>
                              </div>
                              <div class="row m-0">
                                <div class="col-md-12 p-0">
                                  <div class="form-button-step">
                                    <button
                                      type="button"
                                      onClick={() => getLiData(3)}
                                      class="btn themeBtn"
                                    >
                                      Previous
                                    </button>
                                    {selectValue.section4 == null ? (
                                      <button
                                        type="button"
                                        // disabled={selectValue.section4 == null}
                                        // onClick={() => getLiData(5)}
                                        // class="btn themeBtn"
                                        onClick={handleClick}
                                        // onClick={() => getLiData(2)}
                                        className={
                                          isClicked
                                            ? "jerk-button btn themeBtn opacity-35"
                                            : "btn themeBtn opacity-35"
                                        }
                                      >
                                        Next
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        disabled={selectValue.section4 == null}
                                        onClick={() => getLiData(5)}
                                        class="btn themeBtn"
                                      >
                                        Next
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
      
                      {/* <button onClick={() => setSelectValue("section4")}>
                        Select Section 4
                      </button>
                      <button
                        disabled={selectValue == ""}
                        onClick={() => getLiData(5)}
                        className="bg-black text-white"
                      >
                        Next
                      </button> */}
                    </>
                  ) : liData == 5 ? (
                    <>
                      <div class="tab-pane fade" id="stepNew5">
                        <form id="stepForm">
                          <div class="Cal-Form-one">
                            <div class="container p-0">
                              <div class="row flex justify-between items-center w-full">
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont">
                                    <h2>
                                      Do you need extra book promotion? (Choose
                                      Multiple)
                                    </h2>
                                    <div class="form-check px-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="first-check-five-one"
                                        name="section5"
                                        onChange={onSectionFive}
                                        checked={selectValue.section5 == "49"}
                                        value="49"
                                      />
                                      <button
                                        type="button"
                                        class="btn"
                                        data-toggle="modal"
                                        data-target="#quantityModal"
                                      >
                                        <label
                                          class="form-check-label"
                                          for="first-check-five-one"
                                        >
                                          I need to purchase an ISBN number ($49)
                                        </label>
                                      </button>
                                    </div>
                                    <div class="form-check px-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="first-check-five-Two"
                                        // value="option2"
                                        name="section5"
                                        onChange={onSectionFive}
                                        checked={selectValue.section5 == "999"}
                                        value="999"
                                      />
                                      <button
                                        type="button"
                                        class="btn"
                                        data-toggle="modal"
                                        data-target="#quantityModal"
                                      >
                                        <label
                                          class="form-check-label"
                                          for="first-check-five-Two"
                                        >
                                          I already have an ISBN for my book
                                        </label>
                                      </button>
                                    </div>
                                    <div class="form-check px-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="first-check-five-three"
                                        // value="option2"
                                        name="section5"
                                        onChange={onSectionFive}
                                        checked={selectValue.section5 == "10"}
                                        value="10"
                                      />
                                      <button
                                        type="button"
                                        class="btn"
                                        data-toggle="modal"
                                        data-target="#quantityModal"
                                      >
                                        <label
                                          class="form-check-label"
                                          for="first-check-five-three"
                                        >
                                          I don't need an ISBN number
                                        </label>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                    <figure className="flex justify-center items-center">
                                      <img src={PTR200} class="img-fluid" alt="" />
                                    </figure>
                                    <p>
                                      Get the most out of each meet and greet,
                                      speaking engagement, or writer's conference by
                                      using personalized bookmarks and printed
                                      posters—customized with artwork from your book.
                                      11"x17" posters starting at just $49 for 50.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="row m-0 w-full">
                                <div class="col-md-12 p-0">
                                  <div class="form-button-step">
                                    <button
                                      type="button"
                                      onClick={() => getLiData(4)}
                                      class="btn themeBtn"
                                    >
                                      Previous
                                    </button>
                                    {selectValue.section5 == null ? (
                                      <button
                                        type="button"
                                        onClick={handleClick}
                                        // onClick={() => getLiData(2)}
                                        className={
                                          isClicked
                                            ? "jerk-button btn themeBtn opacity-35"
                                            : "btn themeBtn opacity-35"
                                        }
                                      >
                                        Next
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        disabled={selectValue.section5 == null}
                                        onClick={() => getLiData(6)}
                                        class="btn themeBtn"
                                      >
                                        Next
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
      
                      {/* <button onClick={() => setSelectValue("section5")}>
                        Select Section 5
                      </button>
                      <button
                        disabled={selectValue == ""}
                        onClick={() => getLiData(6)}
                        className="bg-black text-white"
                      >
                        Next
                      </button> */}
                    </>
                  ) : liData == 6 ? (
                    <>
                      <div class="tab-pane fade" id="stepNew6">
                        {sidebarLink == "ebookDistribution" ? (
                          <form id="stepForm">
                            <div class="Cal-Form-one">
                              <div class="container p-0">
                                <div class="row flex justify-between items-center w-full">
                                  <div class="col-md-6 w-full">
                                    <div class="Cal-Form-one-cont">
                                      <h2>Do you need extra book promotion?</h2>
                                      <div class="form-check px-2">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          id="first-check-six-one"
                                          name="section6"
                                          onChange={onSectionSix}
                                          checked={selectValue.section6 == "49"}
                                          value="49"
                                        />
                                        <button
                                          type="button"
                                          class="btn"
                                          data-toggle="modal"
                                          data-target="#quantityModal"
                                        >
                                          <label
                                            class="form-check-label"
                                            for="first-check-six-one"
                                          >
                                            I need to purchase an ISBN number ($49)
                                          </label>
                                        </button>
                                      </div>
                                      <div class="form-check px-2">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          id="first-check-Six-Two"
                                          // value="option2"
                                          name="section6"
                                          onChange={onSectionSix}
                                          checked={selectValue.section6 == "499"}
                                          value="499"
                                        />
                                        <button
                                          type="button"
                                          class="btn"
                                          data-toggle="modal"
                                          data-target="#quantityModal"
                                        >
                                          <label
                                            class="form-check-label"
                                            for="first-check-Six-Two"
                                          >
                                            I already have an ISBN for my book
                                          </label>
                                        </button>
                                      </div>
                                      {/* <div class="form-check px-2">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="first-check-Six-three"
                          // value="option2"
                          name="section6"
                          onChange={onSectionSix}
                          checked={selectValue.section6 == "10"}
                          value="10"
                        />
                        <button
                          type="button"
                          class="btn"
                          data-toggle="modal"
                          data-target="#quantityModal"
                        >
                          <label
                            class="form-check-label"
                            for="first-check-Six-three"
                          >
                            I don't need an ISBN number
                          </label>
                        </button>
                      </div> */}
                                    </div>
                                  </div>
                                  <div class="col-md-6 w-full">
                                    <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                      <figure className="flex justify-center items-center">
                                        <img src={PTR200} class="img-fluid" alt="" />
                                      </figure>
                                      <p>
                                        Get the most out of each meet and greet,
                                        speaking engagement, or writer's conference by
                                        using personalized bookmarks and printed
                                        posters—customized with artwork from your
                                        book. 11"x17" posters starting at just $49 for
                                        50.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="row m-0 w-full">
                                  <div class="col-md-12 p-0">
                                    <div class="form-button-step">
                                      <button
                                        type="button"
                                        onClick={() => getLiData(5)}
                                        class="btn themeBtn"
                                      >
                                        Previous
                                      </button>
                                      {selectValue.section6 == null ? (
                                        <button
                                          type="button"
                                          onClick={handleClick}
                                          // onClick={() => getLiData(2)}
                                          className={
                                            isClicked
                                              ? "jerk-button btn themeBtn opacity-35"
                                              : "btn themeBtn opacity-35"
                                          }
                                        >
                                          Next
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          disabled={selectValue.section6 == null}
                                          onClick={() => getLiData(7)}
                                          class="btn themeBtn"
                                        >
                                          Next
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        ) : (
                          <>
                            <h1 className="text-black p-4 !capitalize">
                              Save your project
                            </h1>
      
                            <div className="flex flex-col justify-center mb-8">
                              <div className="flex flex-col justify-center w-full mx-auto">
                                <img
                                  src={BOOK_}
                                  alt="BOOK_"
                                  className="w-2/5 mx-auto"
                                />
                              </div>
                              <div>
                                <h1 className="text-center text-2xl text-black">
                                  Lock in your price now by saving your quote.
                                </h1>
                              </div>
                              <div>
                                <p className="text-center text-black my-3">
                                  Doing so will allow us to email your quote details
                                  right away.
                                </p>
                              </div>
                              <div className="flex justify-center my-3 w-2/4 mx-auto">
                                <input
                                  type="email"
                                  name="section6"
                                  onChange={onSectionSix}
                                  className="border-[1px] border-solid border-gray-500 rounded-sm p-2 w-full"
                                  required
                                />
                              </div>
                            </div>
                            <div class="row m-0 w-full">
                              <div class="col-md-12 p-0">
                                <div class="form-button-step">
                                  <button
                                    type="button"
                                    // onClick={() => getLiData(4)}
                                    onClick={() => getLiData(5)}
                                    class="btn themeBtn"
                                  >
                                    Previous
                                  </button>
                                  <button
                                    type="button"
                                    disabled={selectValue.section6 == null}
                                    onClick={() => onOpenModal("success")}
                                    class="btn themeBtn"
                                  >
                                    Save Project
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {/* <form id="stepForm">
                          <div class="Cal-Form-one">
                            <div class="container p-0">
                              <div class="row flex justify-between items-center w-full">
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont">
                                    <h2>
                                      Do you need extra book promotion? (Choose
                                      Multiple)
                                    </h2>
                                    <div class="form-check px-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="first-check-six-one"
                                      
                                        name="section6"
                                        onChange={onSectionSix}
                                        checked={selectValue.section6 == "49"}
                                        value="49"
                                      />
                                      <button
                                        type="button"
                                        class="btn"
                                        data-toggle="modal"
                                        data-target="#quantityModal"
                                      >
                                        <label
                                          class="form-check-label"
                                          for="first-check-Six-one"
                                        >
                                          I need to purchase an ISBN number ($49)
                                        </label>
                                      </button>
                                    </div>
                                    <div class="form-check px-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="first-check-Six-Two"
                                        // value="option2"
                                        name="section6"
                                        onChange={onSectionSix}
                                        checked={selectValue.section6 == "499"}
                                        value="499"
                                      />
                                      <button
                                        type="button"
                                        class="btn"
                                        data-toggle="modal"
                                        data-target="#quantityModal"
                                      >
                                        <label
                                          class="form-check-label"
                                          for="first-check-Six-Two"
                                        >
                                          I already have an ISBN for my book
                                        </label>
                                      </button>
                                    </div>
                                    <div class="form-check px-2">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="first-check-Six-three"
                                        // value="option2"
                                        name="section6"
                                        onChange={onSectionSix}
                                        checked={selectValue.section6 == "10"}
                                        value="10"
                                      />
                                      <button
                                        type="button"
                                        class="btn"
                                        data-toggle="modal"
                                        data-target="#quantityModal"
                                      >
                                        <label
                                          class="form-check-label"
                                          for="first-check-Six-three"
                                        >
                                          I don't need an ISBN number
                                        </label>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 w-full">
                                  <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                    <figure className="flex justify-center items-center">
                                      <img
                                        src={PTR200}
                                        class="img-fluid"
                                        alt=""
                                      />
                                    </figure>
                                    <p>
                                      Get the most out of each meet and greet,
                                      speaking engagement, or writer's conference by
                                      using personalized bookmarks and printed
                                      posters—customized with artwork from your book.
                                      11"x17" posters starting at just $49 for 50.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="row m-0 w-full">
                                <div class="col-md-12 p-0">
                                  <div class="form-button-step">
                                    <button
                                      type="button"
                                      onClick={() => getLiData(5)}
                                      class="btn themeBtn"
                                    >
                                      Previous
                                    </button>
                                    <button
                                      type="button"
                                      disabled={selectValue.section6 == ""}
                                      onClick={() => getLiData(7)}
                                      class="btn themeBtn"
                                    >
                                      Next
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form> */}
                      </div>
                      {/* <button onClick={() => setSelectValue("section6")}>
                        Select Section 6
                      </button>
                      <button
                        disabled={selectValue == ""}
                        onClick={() => getLiData(7)}
                        className="bg-black text-white"
                      >
                        Next
                      </button> */}
                    </>
                  ) : liData == 7 ? (
                    <>
                      <form id="stepForm">
                        <div class="Cal-Form-one">
                          <div class="container p-0">
                            <div class="row flex justify-between items-center w-full">
                              <div class="col-md-6 w-full">
                                <div class="Cal-Form-one-cont">
                                  <h2>Do you need extra book promotion?</h2>
                                  <div class="form-check px-2">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="first-check-seven-one"
                                      name="section7"
                                      onChange={onSectionSeven}
                                      checked={selectValue.section7 == "49"}
                                      value="49"
                                    />
                                    <button
                                      type="button"
                                      class="btn"
                                      data-toggle="modal"
                                      data-target="#quantityModal"
                                    >
                                      <label
                                        class="form-check-label"
                                        for="first-check-seven-one"
                                      >
                                        I need to purchase an ISBN number ($49)
                                      </label>
                                    </button>
                                  </div>
                                  <div class="form-check px-2">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="first-check-seven-Two"
                                      // value="option2"
                                      name="section7"
                                      onChange={onSectionSeven}
                                      checked={selectValue.section7 == "499"}
                                      value="499"
                                    />
                                    <button
                                      type="button"
                                      class="btn"
                                      data-toggle="modal"
                                      data-target="#quantityModal"
                                    >
                                      <label
                                        class="form-check-label"
                                        for="first-check-seven-Two"
                                      >
                                        I already have an ISBN for my book
                                      </label>
                                    </button>
                                  </div>
                                  <div class="form-check px-2">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="first-check-seven-three"
                                      // value="option2"
                                      name="section7"
                                      onChange={onSectionSeven}
                                      checked={selectValue.section7 == "10"}
                                      value="10"
                                    />
                                    <button
                                      type="button"
                                      class="btn"
                                      data-toggle="modal"
                                      data-target="#quantityModal"
                                    >
                                      <label
                                        class="form-check-label"
                                        for="first-check-seven-three"
                                      >
                                        I don't need an ISBN number
                                      </label>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 w-full">
                                <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                  <figure className="flex justify-center items-center">
                                    <img src={PTR200} class="img-fluid" alt="" />
                                  </figure>
                                  <p>
                                    Get the most out of each meet and greet, speaking
                                    engagement, or writer's conference by using
                                    personalized bookmarks and printed
                                    posters—customized with artwork from your book.
                                    11"x17" posters starting at just $49 for 50.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="row m-0 w-full">
                              <div class="col-md-12 p-0">
                                <div class="form-button-step">
                                  <button
                                    type="button"
                                    onClick={() => getLiData(6)}
                                    class="btn themeBtn"
                                  >
                                    Previous
                                  </button>
                                  {selectValue.section7 == null ? (
                                    <button
                                      type="button"
                                      onClick={handleClick}
                                      // onClick={() => getLiData(2)}
                                      className={
                                        isClicked
                                          ? "jerk-button btn themeBtn opacity-35"
                                          : "btn themeBtn opacity-35"
                                      }
                                    >
                                      Next
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      disabled={selectValue.section7 == null}
                                      onClick={() => getLiData(8)}
                                      class="btn themeBtn"
                                    >
                                      Next
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      {/* <button onClick={() => setSelectValue("section7")}>
                        Select Section 7
                      </button> */}
                      {/* <button
                        disabled={selectValue == ""}
                        onClick={() => getLiData(8)}
                        className="bg-black text-white"
                      >
                        Next
                      </button> */}
                    </>
                  ) : liData == 8 ? (
                    <>
                      {sidebarLink == "ebookDistribution" ? (
                        <>
                          <h1 className="text-black p-4 !capitalize">
                            Save your project
                          </h1>
      
                          <div className="flex flex-col justify-center mb-8">
                            <div className="flex flex-col justify-center w-full mx-auto">
                              <img
                                src={BOOK_}
                                alt="BOOK_"
                                className="w-2/5 mx-auto"
                              />
                            </div>
                            <div>
                              <h1 className="text-center text-2xl text-black">
                                Lock in your price now by saving your quote.
                              </h1>
                            </div>
                            <div>
                              <p className="text-center text-black my-3">
                                Doing so will allow us to email your quote details
                                right away.
                              </p>
                            </div>
                            <div className="flex justify-center my-3 w-2/4 mx-auto">
                              <input
                                type="email"
                                name="section8"
                                onChange={onSectionEight}
                                className="border-[1px] border-solid border-gray-500 rounded-sm p-2 w-full"
                                required
                              />
                            </div>
                          </div>
                          <div class="row m-0 w-full">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  // onClick={() => getLiData(4)}
                                  onClick={() => getLiData(7)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section8 == null ? (
                                  <button
                                    type="button"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Save Project
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section8 == null}
                                    onClick={() => onOpenModal("success")}
                                    class="btn themeBtn"
                                  >
                                    Save Project
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
      
                      {/* <button onClick={() => setSelectValue("section8")}>
                        Select Section 8
                      </button>
                      <button
                        disabled={selectValue == ""}
                        onClick={() => getLiData(9)}
                        className="bg-black text-white"
                      >
                        Next
                      </button> */}
                    </>
                  ) : (
                    <>
                      <button onClick={() => setSelectValue("section9")}>
                        Select Section 9
                      </button>
                  
                    </>
                  )
            ): queryValue == "ebook" ? (
              liData == 1 ? (
                <>
                  <div class="tab-pane fade show active" id="stepNew1">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need book Ebook distribution?</h2>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input !text-[#c65300]"
                                    type="radio"
                                    checked={selectValue.section1 === "399"}
                                    onChange={onChangeAllValue}
                                    name="section1"
                                    value="399"
                                    id="first-check-one"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-one"
                                  >
                                    Printed on Demand (Global Retailers) ($399)
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input !text-[#c65300]"
                                    onChange={onChangeAllValue}
                                    checked={selectValue.section1 === "149"}
                                    type="radio"
                                    name="section1"
                                    id="first-check-two"
                                    value="149"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-two"
                                  >
                                    Print On Demand (Bookshop™ Only) ($149)
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input !text-[#c65300]"
                                    onChange={onChangeAllValue}
                                    checked={selectValue.section1 === "0"}
                                    type="radio"
                                    id="first-check-Three"
                                    name="section1"
                                    value="0"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-Three"
                                  >
                                    I don't need printed book distribution
                                  </label>
                                </div>
                              </div>
                            </div>
  
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                <figure className="flex flex-col justify-center items-center">
                                  <img src={BBP_POD} class="img-fluid" alt="" />
                                </figure>
                                <p>
                                  Make your book available for sale with the
                                  largest network of global booksellers,
                                  libraries, and online retailers. Includes
                                  distribution to Amazon, Powell’s, Barnes &
                                  Noble, Ingram, Baker & Taylor, and 50+ others.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  // class="btn themeBtn"
                                  // disabled
                                  onClick={handleClickFunc}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      prevClicked
                                        ? "jerk-button btn themeBtn"
                                        : "btn themeBtn"
                                    }
                                >
                                  Previous
                                </button>
                                {selectValue.section1 == null ? (
                                  <button
                                    type="button"
                                    // class="btn themeBtn"
                                    // disabled={selectValue.section1 == null}
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    class="btn themeBtn"
                                    disabled={selectValue.section1 == null}
                                    onClick={() => getLiData(2)}
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section1")}>
              Select Section One
            </button> */}
                  {/* <button
              disabled={selectValue == ""}
              onClick={() => getLiData(2)}
              className="bg-black text-white"
            >
              Next
            </button> */}
                </>
              ) : liData == 2 ? (
                <>
                  <div class="tab-pane fade" id="stepNew2">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need Ebook formatting?</h2>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    value="100"
                                    name="section2"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "100"}
                                    id="second-check-one"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="second-check-one"
                                  >
                                    I need text formatting
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    value="200"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "200"}
                                    id="second-check-two"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for={"second-check-two"}
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
  
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "300"}
                                    value="300"
                                    id="second-check-three"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for={"second-check-three"}
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
  
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    value="400"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "400"}
                                    id="second-check-four"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="second-check-four"
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
  
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    value="500"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "500"}
                                    id="second-check-five"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="second-check-five"
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex justify-center flex-col items-center">
                                <figure class="flex justify-center flex-col items-center">
                                  <img
                                    src={BBP_POD}
                                    class="img-fluid !w-4/5"
                                    alt=""
                                  />
                                </figure>
                                <p>
                                  Make your book available for sale with the
                                  largest network of global booksellers,
                                  libraries, and online retailers. Includes
                                  distribution to Amazon, Powell’s, Barnes &
                                  Noble, Ingram, Baker & Taylor, and 50+ others.
                                </p>
                              </div>
                            </div>
                          </div>
  
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(1)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section2 == null ? (
                                  <button
                                    type="button"
                                    // disabled={selectValue.section2 == null}
                                    // class="btn themeBtn"
                                    onClick={handleClick}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section2 == null}
                                    onClick={() => getLiData(3)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section2")}>
                    Select Section Two
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(3)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 3 ? (
                <>
                  <div class="tab-pane fade" id="stepNew3">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need Ebook design?</h2>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input "
                                    type="radio"
                                    id="first-check-three-one"
                                    value="599"
                                    onChange={onSectionThree}
                                    checked={selectValue.section3 == "599"}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-three-one"
                                  >
                                    Professional Cover Design ($599)
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input "
                                    type="radio"
                                    id="first-check-three-Two"
                                    value="50"
                                    onChange={onSectionThree}
                                    checked={selectValue.section3 == "50"}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-three-Two"
                                  >
                                    I am supplying my cover design
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont  flex justify-center flex-col items-center">
                                <figure className=" flex justify-center items-center">
                                  <img src={BBP_POD} class="img-fluid" alt="" />
                                </figure>
                                <p>
                                  Make your book available for sale with the
                                  largest network of global booksellers,
                                  libraries, and online retailers. Includes
                                  distribution to Amazon, Powell’s, Barnes &
                                  Noble, Ingram, Baker & Taylor, and 50+ others.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(2)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section3 == null ? (
                                  <button
                                    type="button"
                                    // disabled={selectValue.section3 == null}
                                    // onClick={() => getLiData(4)}
                                    // class="btn themeBtn"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section3 == null}
                                    onClick={() => getLiData(4)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section3")}>
                    Select Section 3
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(4)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 4 ? (
                <>
                  <div class="tab-pane fade" id="stepNew4">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between items-center w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need an ISBN For Ebook?</h2>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-four-one"
                                    name="section4"
                                    onChange={onSectionFour}
                                    checked={selectValue.section4 == "49"}
                                    value="49"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-four-one"
                                  >
                                    I need to purchase an ISBN number ($49)
                                  </label>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-four-Two"
                                    name="section4"
                                    onChange={onSectionFour}
                                    checked={selectValue.section4 == "99"}
                                    value="99"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-four-Two"
                                  >
                                    I already have an ISBN for my book
                                  </label>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input "
                                    type="radio"
                                    id="first-check-four-three"
                                    name="section4"
                                    onChange={onSectionFour}
                                    checked={selectValue.section4 == "149"}
                                    value="149"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-four-three"
                                  >
                                    I don't need an ISBN number
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <figure className="flex justify-center items-center">
                                  <img src={BBP_POD_1} class="img-fluid" alt="" />
                                </figure>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(3)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section4 == null ? (
                                  <button
                                    type="button"
                                    // disabled={selectValue.section4 == null}
                                    // onClick={() => getLiData(5)}
                                    // class="btn themeBtn"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section4 == null}
                                    onClick={() => getLiData(5)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section4")}>
                    Select Section 4
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(5)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 5 ? (
                <>
                  <div class="tab-pane fade" id="stepNew5">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between items-center w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>
                                  Do you need extra e-book promotion? (Choose
                                  Multiple)
                                </h2>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-five-one"
                                    name="section5"
                                    onChange={onSectionFive}
                                    checked={selectValue.section5 == "49"}
                                    value="49"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-five-one"
                                    >
                                      I need to purchase an ISBN number ($49)
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-five-Two"
                                    // value="option2"
                                    name="section5"
                                    onChange={onSectionFive}
                                    checked={selectValue.section5 == "999"}
                                    value="999"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-five-Two"
                                    >
                                      I already have an ISBN for my book
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-five-three"
                                    // value="option2"
                                    name="section5"
                                    onChange={onSectionFive}
                                    checked={selectValue.section5 == "10"}
                                    value="10"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-five-three"
                                    >
                                      I don't need an ISBN number
                                    </label>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                <figure className="flex justify-center items-center">
                                  <img src={PTR200} class="img-fluid" alt="" />
                                </figure>
                                <p>
                                  Get the most out of each meet and greet,
                                  speaking engagement, or writer's conference by
                                  using personalized bookmarks and printed
                                  posters—customized with artwork from your book.
                                  11"x17" posters starting at just $49 for 50.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0 w-full">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(4)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section5 == null ? (
                                  <button
                                    type="button"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section5 == null}
                                    onClick={() => getLiData(6)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section5")}>
                    Select Section 5
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(6)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 6 ? (
                <>
                  <div class="tab-pane fade" id="stepNew6">
                    {sidebarLink == "ebookDistribution" ? (
                      <form id="stepForm">
                        <div class="Cal-Form-one">
                          <div class="container p-0">
                            <div class="row flex justify-between items-center w-full">
                              <div class="col-md-6 w-full">
                                <div class="Cal-Form-one-cont">
                                  <h2>Do you need extra Ebook promotion?</h2>
                                  <div class="form-check px-2">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="first-check-six-one"
                                      name="section6"
                                      onChange={onSectionSix}
                                      checked={selectValue.section6 == "49"}
                                      value="49"
                                    />
                                    <button
                                      type="button"
                                      class="btn"
                                      data-toggle="modal"
                                      data-target="#quantityModal"
                                    >
                                      <label
                                        class="form-check-label"
                                        for="first-check-six-one"
                                      >
                                        I need to purchase an ISBN number ($49)
                                      </label>
                                    </button>
                                  </div>
                                  <div class="form-check px-2">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="first-check-Six-Two"
                                      // value="option2"
                                      name="section6"
                                      onChange={onSectionSix}
                                      checked={selectValue.section6 == "499"}
                                      value="499"
                                    />
                                    <button
                                      type="button"
                                      class="btn"
                                      data-toggle="modal"
                                      data-target="#quantityModal"
                                    >
                                      <label
                                        class="form-check-label"
                                        for="first-check-Six-Two"
                                      >
                                        I already have an ISBN for my book
                                      </label>
                                    </button>
                                  </div>
                                  {/* <div class="form-check px-2">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="first-check-Six-three"
                      // value="option2"
                      name="section6"
                      onChange={onSectionSix}
                      checked={selectValue.section6 == "10"}
                      value="10"
                    />
                    <button
                      type="button"
                      class="btn"
                      data-toggle="modal"
                      data-target="#quantityModal"
                    >
                      <label
                        class="form-check-label"
                        for="first-check-Six-three"
                      >
                        I don't need an ISBN number
                      </label>
                    </button>
                  </div> */}
                                </div>
                              </div>
                              <div class="col-md-6 w-full">
                                <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                  <figure className="flex justify-center items-center">
                                    <img src={PTR200} class="img-fluid" alt="" />
                                  </figure>
                                  <p>
                                    Get the most out of each meet and greet,
                                    speaking engagement, or writer's conference by
                                    using personalized bookmarks and printed
                                    posters—customized with artwork from your
                                    book. 11"x17" posters starting at just $49 for
                                    50.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="row m-0 w-full">
                              <div class="col-md-12 p-0">
                                <div class="form-button-step">
                                  <button
                                    type="button"
                                    onClick={() => getLiData(5)}
                                    class="btn themeBtn"
                                  >
                                    Previous
                                  </button>
                                  {selectValue.section6 == null ? (
                                    <button
                                      type="button"
                                      onClick={handleClick}
                                      // onClick={() => getLiData(2)}
                                      className={
                                        isClicked
                                          ? "jerk-button btn themeBtn opacity-35"
                                          : "btn themeBtn opacity-35"
                                      }
                                    >
                                      Next
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      disabled={selectValue.section6 == null}
                                      onClick={() => getLiData(7)}
                                      class="btn themeBtn"
                                    >
                                      Next
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <>
                        <h1 className="text-black p-4 !capitalize">
                          Save your project
                        </h1>
  
                        <div className="flex flex-col justify-center mb-8">
                          <div className="flex flex-col justify-center w-full mx-auto">
                            <img
                              src={BOOK_}
                              alt="BOOK_"
                              className="w-2/5 mx-auto"
                            />
                          </div>
                          <div>
                            <h1 className="text-center text-2xl text-black">
                              Lock in your price now by saving your quote.
                            </h1>
                          </div>
                          <div>
                            <p className="text-center text-black my-3">
                              Doing so will allow us to email your quote details
                              right away.
                            </p>
                          </div>
                          <div className="flex justify-center my-3 w-2/4 mx-auto">
                            <input
                              type="email"
                              name="section6"
                              onChange={onSectionSix}
                              className="border-[1px] border-solid border-gray-500 rounded-sm p-2 w-full"
                              required
                            />
                          </div>
                        </div>
                        <div class="row m-0 w-full">
                          <div class="col-md-12 p-0">
                            <div class="form-button-step">
                              <button
                                type="button"
                                // onClick={() => getLiData(4)}
                                onClick={() => getLiData(5)}
                                class="btn themeBtn"
                              >
                                Previous
                              </button>
                              <button
                                type="button"
                                disabled={selectValue.section6 == null}
                                onClick={() => onOpenModal("success")}
                                class="btn themeBtn"
                              >
                                Save Project
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {/* <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between items-center w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>
                                  Do you need extra book promotion? (Choose
                                  Multiple)
                                </h2>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-six-one"
                                  
                                    name="section6"
                                    onChange={onSectionSix}
                                    checked={selectValue.section6 == "49"}
                                    value="49"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-Six-one"
                                    >
                                      I need to purchase an ISBN number ($49)
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-Six-Two"
                                    // value="option2"
                                    name="section6"
                                    onChange={onSectionSix}
                                    checked={selectValue.section6 == "499"}
                                    value="499"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-Six-Two"
                                    >
                                      I already have an ISBN for my book
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-Six-three"
                                    // value="option2"
                                    name="section6"
                                    onChange={onSectionSix}
                                    checked={selectValue.section6 == "10"}
                                    value="10"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-Six-three"
                                    >
                                      I don't need an ISBN number
                                    </label>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                <figure className="flex justify-center items-center">
                                  <img
                                    src={PTR200}
                                    class="img-fluid"
                                    alt=""
                                  />
                                </figure>
                                <p>
                                  Get the most out of each meet and greet,
                                  speaking engagement, or writer's conference by
                                  using personalized bookmarks and printed
                                  posters—customized with artwork from your book.
                                  11"x17" posters starting at just $49 for 50.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0 w-full">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(5)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                <button
                                  type="button"
                                  disabled={selectValue.section6 == ""}
                                  onClick={() => getLiData(7)}
                                  class="btn themeBtn"
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form> */}
                  </div>
                  {/* <button onClick={() => setSelectValue("section6")}>
                    Select Section 6
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(7)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 7 ? (
                <>
                  <form id="stepForm">
                    <div class="Cal-Form-one">
                      <div class="container p-0">
                        <div class="row flex justify-between items-center w-full">
                          <div class="col-md-6 w-full">
                            <div class="Cal-Form-one-cont">
                              <h2>Do you need extra book promotion?</h2>
                              <div class="form-check px-2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  id="first-check-seven-one"
                                  name="section7"
                                  onChange={onSectionSeven}
                                  checked={selectValue.section7 == "49"}
                                  value="49"
                                />
                                <button
                                  type="button"
                                  class="btn"
                                  data-toggle="modal"
                                  data-target="#quantityModal"
                                >
                                  <label
                                    class="form-check-label"
                                    for="first-check-seven-one"
                                  >
                                    I need to purchase an ISBN number ($49)
                                  </label>
                                </button>
                              </div>
                              <div class="form-check px-2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  id="first-check-seven-Two"
                                  // value="option2"
                                  name="section7"
                                  onChange={onSectionSeven}
                                  checked={selectValue.section7 == "499"}
                                  value="499"
                                />
                                <button
                                  type="button"
                                  class="btn"
                                  data-toggle="modal"
                                  data-target="#quantityModal"
                                >
                                  <label
                                    class="form-check-label"
                                    for="first-check-seven-Two"
                                  >
                                    I already have an ISBN for my book
                                  </label>
                                </button>
                              </div>
                              <div class="form-check px-2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  id="first-check-seven-three"
                                  // value="option2"
                                  name="section7"
                                  onChange={onSectionSeven}
                                  checked={selectValue.section7 == "10"}
                                  value="10"
                                />
                                <button
                                  type="button"
                                  class="btn"
                                  data-toggle="modal"
                                  data-target="#quantityModal"
                                >
                                  <label
                                    class="form-check-label"
                                    for="first-check-seven-three"
                                  >
                                    I don't need an ISBN number
                                  </label>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 w-full">
                            <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                              <figure className="flex justify-center items-center">
                                <img src={PTR200} class="img-fluid" alt="" />
                              </figure>
                              <p>
                                Get the most out of each meet and greet, speaking
                                engagement, or writer's conference by using
                                personalized bookmarks and printed
                                posters—customized with artwork from your book.
                                11"x17" posters starting at just $49 for 50.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="row m-0 w-full">
                          <div class="col-md-12 p-0">
                            <div class="form-button-step">
                              <button
                                type="button"
                                onClick={() => getLiData(6)}
                                class="btn themeBtn"
                              >
                                Previous
                              </button>
                              {selectValue.section7 == null ? (
                                <button
                                  type="button"
                                  onClick={handleClick}
                                  // onClick={() => getLiData(2)}
                                  className={
                                    isClicked
                                      ? "jerk-button btn themeBtn opacity-35"
                                      : "btn themeBtn opacity-35"
                                  }
                                >
                                  Next
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  disabled={selectValue.section7 == null}
                                  onClick={() => getLiData(8)}
                                  class="btn themeBtn"
                                >
                                  Next
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {/* <button onClick={() => setSelectValue("section7")}>
                    Select Section 7
                  </button> */}
                  {/* <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(8)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 8 ? (
                <>
                  {sidebarLink == "ebookDistribution" ? (
                    <>
                      <h1 className="text-black p-4 !capitalize">
                        Save your project
                      </h1>
  
                      <div className="flex flex-col justify-center mb-8">
                        <div className="flex flex-col justify-center w-full mx-auto">
                          <img
                            src={BOOK_}
                            alt="BOOK_"
                            className="w-2/5 mx-auto"
                          />
                        </div>
                        <div>
                          <h1 className="text-center text-2xl text-black">
                            Lock in your price now by saving your quote.
                          </h1>
                        </div>
                        <div>
                          <p className="text-center text-black my-3">
                            Doing so will allow us to email your quote details
                            right away.
                          </p>
                        </div>
                        <div className="flex justify-center my-3 w-2/4 mx-auto">
                          <input
                            type="email"
                            name="section8"
                            onChange={onSectionEight}
                            className="border-[1px] border-solid border-gray-500 rounded-sm p-2 w-full"
                            required
                          />
                        </div>
                      </div>
                      <div class="row m-0 w-full">
                        <div class="col-md-12 p-0">
                          <div class="form-button-step">
                            <button
                              type="button"
                              // onClick={() => getLiData(4)}
                              onClick={() => getLiData(7)}
                              class="btn themeBtn"
                            >
                              Previous
                            </button>
                            {selectValue.section8 == null ? (
                              <button
                                type="button"
                                onClick={handleClick}
                                // onClick={() => getLiData(2)}
                                className={
                                  isClicked
                                    ? "jerk-button btn themeBtn opacity-35"
                                    : "btn themeBtn opacity-35"
                                }
                              >
                                Save Project
                              </button>
                            ) : (
                              <button
                                type="button"
                                disabled={selectValue.section8 == null}
                                onClick={() => onOpenModal("success")}
                                class="btn themeBtn"
                              >
                                Save Project
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
  
                  {/* <button onClick={() => setSelectValue("section8")}>
                    Select Section 8
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(9)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : (
                <>
                  <button onClick={() => setSelectValue("section9")}>
                    Select Section 9
                  </button>
              
                </>
              )

            ) :  queryValue == "ebookandprinted" ? (
              liData == 1 ? (
                <>
                  <div class="tab-pane fade show active" id="stepNew1">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need book E-book  and Printing?</h2>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input !text-[#c65300]"
                                    type="radio"
                                    checked={selectValue.section1 === "399"}
                                    onChange={onChangeAllValue}
                                    name="section1"
                                    value="399"
                                    id="first-check-one"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-one"
                                  >
                                    Printed on Demand (Global Retailers) ($399)
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input !text-[#c65300]"
                                    onChange={onChangeAllValue}
                                    checked={selectValue.section1 === "149"}
                                    type="radio"
                                    name="section1"
                                    id="first-check-two"
                                    value="149"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-two"
                                  >
                                    Print On Demand (Bookshop™ Only) ($149)
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input !text-[#c65300]"
                                    onChange={onChangeAllValue}
                                    checked={selectValue.section1 === "0"}
                                    type="radio"
                                    id="first-check-Three"
                                    name="section1"
                                    value="0"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-Three"
                                  >
                                    I don't need printed book distribution
                                  </label>
                                </div>
                              </div>
                            </div>
  
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                <figure className="flex flex-col justify-center items-center">
                                  <img src={BBP_POD} class="img-fluid" alt="" />
                                </figure>
                                <p>
                                  Make your book available for sale with the
                                  largest network of global booksellers,
                                  libraries, and online retailers. Includes
                                  distribution to Amazon, Powell’s, Barnes &
                                  Noble, Ingram, Baker & Taylor, and 50+ others.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  // class="btn themeBtn"
                                  // disabled
                                  onClick={handleClickFunc}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      prevClicked
                                        ? "jerk-button btn themeBtn"
                                        : "btn themeBtn"
                                    }
                                >
                                  Previous
                                </button>
                                {selectValue.section1 == null ? (
                                  <button
                                    type="button"
                                    // class="btn themeBtn"
                                    // disabled={selectValue.section1 == null}
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    class="btn themeBtn"
                                    disabled={selectValue.section1 == null}
                                    onClick={() => getLiData(2)}
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section1")}>
              Select Section One
            </button> */}
                  {/* <button
              disabled={selectValue == ""}
              onClick={() => getLiData(2)}
              className="bg-black text-white"
            >
              Next
            </button> */}
                </>
              ) : liData == 2 ? (
                <>
                  <div class="tab-pane fade" id="stepNew2">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need text E-book  and Printing formating?</h2>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    value="100"
                                    name="section2"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "100"}
                                    id="second-check-one"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="second-check-one"
                                  >
                                    I need text formatting
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    value="200"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "200"}
                                    id="second-check-two"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for={"second-check-two"}
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
  
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "300"}
                                    value="300"
                                    id="second-check-three"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for={"second-check-three"}
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
  
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    value="400"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "400"}
                                    id="second-check-four"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="second-check-four"
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
  
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    value="500"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "500"}
                                    id="second-check-five"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="second-check-five"
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex justify-center flex-col items-center">
                                <figure class="flex justify-center flex-col items-center">
                                  <img
                                    src={BBP_POD}
                                    class="img-fluid !w-4/5"
                                    alt=""
                                  />
                                </figure>
                                <p>
                                  Make your book available for sale with the
                                  largest network of global booksellers,
                                  libraries, and online retailers. Includes
                                  distribution to Amazon, Powell’s, Barnes &
                                  Noble, Ingram, Baker & Taylor, and 50+ others.
                                </p>
                              </div>
                            </div>
                          </div>
  
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(1)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section2 == null ? (
                                  <button
                                    type="button"
                                    // disabled={selectValue.section2 == null}
                                    // class="btn themeBtn"
                                    onClick={handleClick}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section2 == null}
                                    onClick={() => getLiData(3)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section2")}>
                    Select Section Two
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(3)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 3 ? (
                <>
                  <div class="tab-pane fade" id="stepNew3">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need cover design?</h2>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input "
                                    type="radio"
                                    id="first-check-three-one"
                                    value="599"
                                    onChange={onSectionThree}
                                    checked={selectValue.section3 == "599"}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-three-one"
                                  >
                                    Professional Cover Design ($599)
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input "
                                    type="radio"
                                    id="first-check-three-Two"
                                    value="50"
                                    onChange={onSectionThree}
                                    checked={selectValue.section3 == "50"}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-three-Two"
                                  >
                                    I am supplying my cover design
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont  flex justify-center flex-col items-center">
                                <figure className=" flex justify-center items-center">
                                  <img src={BBP_POD} class="img-fluid" alt="" />
                                </figure>
                                <p>
                                  Make your book available for sale with the
                                  largest network of global booksellers,
                                  libraries, and online retailers. Includes
                                  distribution to Amazon, Powell’s, Barnes &
                                  Noble, Ingram, Baker & Taylor, and 50+ others.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(2)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section3 == null ? (
                                  <button
                                    type="button"
                                    // disabled={selectValue.section3 == null}
                                    // onClick={() => getLiData(4)}
                                    // class="btn themeBtn"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section3 == null}
                                    onClick={() => getLiData(4)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section3")}>
                    Select Section 3
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(4)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 4 ? (
                <>
                  <div class="tab-pane fade" id="stepNew4">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between items-center w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need an ISBN for E-book  and Printing?</h2>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-four-one"
                                    name="section4"
                                    onChange={onSectionFour}
                                    checked={selectValue.section4 == "49"}
                                    value="49"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-four-one"
                                  >
                                    I need to purchase an ISBN number ($49)
                                  </label>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-four-Two"
                                    name="section4"
                                    onChange={onSectionFour}
                                    checked={selectValue.section4 == "99"}
                                    value="99"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-four-Two"
                                  >
                                    I already have an ISBN for my book
                                  </label>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input "
                                    type="radio"
                                    id="first-check-four-three"
                                    name="section4"
                                    onChange={onSectionFour}
                                    checked={selectValue.section4 == "149"}
                                    value="149"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-four-three"
                                  >
                                    I don't need an ISBN number
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <figure className="flex justify-center items-center">
                                  <img src={BBP_POD_1} class="img-fluid" alt="" />
                                </figure>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(3)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section4 == null ? (
                                  <button
                                    type="button"
                                    // disabled={selectValue.section4 == null}
                                    // onClick={() => getLiData(5)}
                                    // class="btn themeBtn"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section4 == null}
                                    onClick={() => getLiData(5)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section4")}>
                    Select Section 4
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(5)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 5 ? (
                <>
                  <div class="tab-pane fade" id="stepNew5">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between items-center w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>
                                  Do you need extra E-book  and Printing promotion? (Choose
                                  Multiple)
                                </h2>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-five-one"
                                    name="section5"
                                    onChange={onSectionFive}
                                    checked={selectValue.section5 == "49"}
                                    value="49"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-five-one"
                                    >
                                      I need to purchase an ISBN number ($49)
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-five-Two"
                                    // value="option2"
                                    name="section5"
                                    onChange={onSectionFive}
                                    checked={selectValue.section5 == "999"}
                                    value="999"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-five-Two"
                                    >
                                      I already have an ISBN for my book
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-five-three"
                                    // value="option2"
                                    name="section5"
                                    onChange={onSectionFive}
                                    checked={selectValue.section5 == "10"}
                                    value="10"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-five-three"
                                    >
                                      I don't need an ISBN number
                                    </label>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                <figure className="flex justify-center items-center">
                                  <img src={PTR200} class="img-fluid" alt="" />
                                </figure>
                                <p>
                                  Get the most out of each meet and greet,
                                  speaking engagement, or writer's conference by
                                  using personalized bookmarks and printed
                                  posters—customized with artwork from your book.
                                  11"x17" posters starting at just $49 for 50.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0 w-full">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(4)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section5 == null ? (
                                  <button
                                    type="button"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section5 == null}
                                    onClick={() => getLiData(6)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section5")}>
                    Select Section 5
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(6)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 6 ? (
                <>
                  <div class="tab-pane fade" id="stepNew6">
                    {sidebarLink == "ebookDistribution" ? (
                      <form id="stepForm">
                        <div class="Cal-Form-one">
                          <div class="container p-0">
                            <div class="row flex justify-between items-center w-full">
                              <div class="col-md-6 w-full">
                                <div class="Cal-Form-one-cont">
                                  <h2>Do you need extra book E-book  and Printing promotion?</h2>
                                  <div class="form-check px-2">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="first-check-six-one"
                                      name="section6"
                                      onChange={onSectionSix}
                                      checked={selectValue.section6 == "49"}
                                      value="49"
                                    />
                                    <button
                                      type="button"
                                      class="btn"
                                      data-toggle="modal"
                                      data-target="#quantityModal"
                                    >
                                      <label
                                        class="form-check-label"
                                        for="first-check-six-one"
                                      >
                                        I need to purchase an ISBN number ($49)
                                      </label>
                                    </button>
                                  </div>
                                  <div class="form-check px-2">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="first-check-Six-Two"
                                      // value="option2"
                                      name="section6"
                                      onChange={onSectionSix}
                                      checked={selectValue.section6 == "499"}
                                      value="499"
                                    />
                                    <button
                                      type="button"
                                      class="btn"
                                      data-toggle="modal"
                                      data-target="#quantityModal"
                                    >
                                      <label
                                        class="form-check-label"
                                        for="first-check-Six-Two"
                                      >
                                        I already have an ISBN for my book
                                      </label>
                                    </button>
                                  </div>
                                  {/* <div class="form-check px-2">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="first-check-Six-three"
                      // value="option2"
                      name="section6"
                      onChange={onSectionSix}
                      checked={selectValue.section6 == "10"}
                      value="10"
                    />
                    <button
                      type="button"
                      class="btn"
                      data-toggle="modal"
                      data-target="#quantityModal"
                    >
                      <label
                        class="form-check-label"
                        for="first-check-Six-three"
                      >
                        I don't need an ISBN number
                      </label>
                    </button>
                  </div> */}
                                </div>
                              </div>
                              <div class="col-md-6 w-full">
                                <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                  <figure className="flex justify-center items-center">
                                    <img src={PTR200} class="img-fluid" alt="" />
                                  </figure>
                                  <p>
                                    Get the most out of each meet and greet,
                                    speaking engagement, or writer's conference by
                                    using personalized bookmarks and printed
                                    posters—customized with artwork from your
                                    book. 11"x17" posters starting at just $49 for
                                    50.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="row m-0 w-full">
                              <div class="col-md-12 p-0">
                                <div class="form-button-step">
                                  <button
                                    type="button"
                                    onClick={() => getLiData(5)}
                                    class="btn themeBtn"
                                  >
                                    Previous
                                  </button>
                                  {selectValue.section6 == null ? (
                                    <button
                                      type="button"
                                      onClick={handleClick}
                                      // onClick={() => getLiData(2)}
                                      className={
                                        isClicked
                                          ? "jerk-button btn themeBtn opacity-35"
                                          : "btn themeBtn opacity-35"
                                      }
                                    >
                                      Next
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      disabled={selectValue.section6 == null}
                                      onClick={() => getLiData(7)}
                                      class="btn themeBtn"
                                    >
                                      Next
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <>
                        <h1 className="text-black p-4 !capitalize">
                          Save your project
                        </h1>
  
                        <div className="flex flex-col justify-center mb-8">
                          <div className="flex flex-col justify-center w-full mx-auto">
                            <img
                              src={BOOK_}
                              alt="BOOK_"
                              className="w-2/5 mx-auto"
                            />
                          </div>
                          <div>
                            <h1 className="text-center text-2xl text-black">
                              Lock in your price now by saving your quote.
                            </h1>
                          </div>
                          <div>
                            <p className="text-center text-black my-3">
                              Doing so will allow us to email your quote details
                              right away.
                            </p>
                          </div>
                          <div className="flex justify-center my-3 w-2/4 mx-auto">
                            <input
                              type="email"
                              name="section6"
                              onChange={onSectionSix}
                              className="border-[1px] border-solid border-gray-500 rounded-sm p-2 w-full"
                              required
                            />
                          </div>
                        </div>
                        <div class="row m-0 w-full">
                          <div class="col-md-12 p-0">
                            <div class="form-button-step">
                              <button
                                type="button"
                                // onClick={() => getLiData(4)}
                                onClick={() => getLiData(5)}
                                class="btn themeBtn"
                              >
                                Previous
                              </button>
                              <button
                                type="button"
                                disabled={selectValue.section6 == null}
                                onClick={() => onOpenModal("success")}
                                class="btn themeBtn"
                              >
                                Save Project
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {/* <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between items-center w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>
                                  Do you need extra book promotion? (Choose
                                  Multiple)
                                </h2>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-six-one"
                                  
                                    name="section6"
                                    onChange={onSectionSix}
                                    checked={selectValue.section6 == "49"}
                                    value="49"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-Six-one"
                                    >
                                      I need to purchase an ISBN number ($49)
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-Six-Two"
                                    // value="option2"
                                    name="section6"
                                    onChange={onSectionSix}
                                    checked={selectValue.section6 == "499"}
                                    value="499"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-Six-Two"
                                    >
                                      I already have an ISBN for my book
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-Six-three"
                                    // value="option2"
                                    name="section6"
                                    onChange={onSectionSix}
                                    checked={selectValue.section6 == "10"}
                                    value="10"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-Six-three"
                                    >
                                      I don't need an ISBN number
                                    </label>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                <figure className="flex justify-center items-center">
                                  <img
                                    src={PTR200}
                                    class="img-fluid"
                                    alt=""
                                  />
                                </figure>
                                <p>
                                  Get the most out of each meet and greet,
                                  speaking engagement, or writer's conference by
                                  using personalized bookmarks and printed
                                  posters—customized with artwork from your book.
                                  11"x17" posters starting at just $49 for 50.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0 w-full">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(5)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                <button
                                  type="button"
                                  disabled={selectValue.section6 == ""}
                                  onClick={() => getLiData(7)}
                                  class="btn themeBtn"
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form> */}
                  </div>
                  {/* <button onClick={() => setSelectValue("section6")}>
                    Select Section 6
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(7)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 7 ? (
                <>
                  <form id="stepForm">
                    <div class="Cal-Form-one">
                      <div class="container p-0">
                        <div class="row flex justify-between items-center w-full">
                          <div class="col-md-6 w-full">
                            <div class="Cal-Form-one-cont">
                              <h2>Do you need extra E-book  and Printing  Promotion?</h2>
                              <div class="form-check px-2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  id="first-check-seven-one"
                                  name="section7"
                                  onChange={onSectionSeven}
                                  checked={selectValue.section7 == "49"}
                                  value="49"
                                />
                                <button
                                  type="button"
                                  class="btn"
                                  data-toggle="modal"
                                  data-target="#quantityModal"
                                >
                                  <label
                                    class="form-check-label"
                                    for="first-check-seven-one"
                                  >
                                    I need to purchase an ISBN number ($49)
                                  </label>
                                </button>
                              </div>
                              <div class="form-check px-2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  id="first-check-seven-Two"
                                  // value="option2"
                                  name="section7"
                                  onChange={onSectionSeven}
                                  checked={selectValue.section7 == "499"}
                                  value="499"
                                />
                                <button
                                  type="button"
                                  class="btn"
                                  data-toggle="modal"
                                  data-target="#quantityModal"
                                >
                                  <label
                                    class="form-check-label"
                                    for="first-check-seven-Two"
                                  >
                                    I already have an ISBN for my book
                                  </label>
                                </button>
                              </div>
                              <div class="form-check px-2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  id="first-check-seven-three"
                                  // value="option2"
                                  name="section7"
                                  onChange={onSectionSeven}
                                  checked={selectValue.section7 == "10"}
                                  value="10"
                                />
                                <button
                                  type="button"
                                  class="btn"
                                  data-toggle="modal"
                                  data-target="#quantityModal"
                                >
                                  <label
                                    class="form-check-label"
                                    for="first-check-seven-three"
                                  >
                                    I don't need an ISBN number
                                  </label>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 w-full">
                            <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                              <figure className="flex justify-center items-center">
                                <img src={PTR200} class="img-fluid" alt="" />
                              </figure>
                              <p>
                                Get the most out of each meet and greet, speaking
                                engagement, or writer's conference by using
                                personalized bookmarks and printed
                                posters—customized with artwork from your book.
                                11"x17" posters starting at just $49 for 50.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="row m-0 w-full">
                          <div class="col-md-12 p-0">
                            <div class="form-button-step">
                              <button
                                type="button"
                                onClick={() => getLiData(6)}
                                class="btn themeBtn"
                              >
                                Previous
                              </button>
                              {selectValue.section7 == null ? (
                                <button
                                  type="button"
                                  onClick={handleClick}
                                  // onClick={() => getLiData(2)}
                                  className={
                                    isClicked
                                      ? "jerk-button btn themeBtn opacity-35"
                                      : "btn themeBtn opacity-35"
                                  }
                                >
                                  Next
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  disabled={selectValue.section7 == null}
                                  onClick={() => getLiData(8)}
                                  class="btn themeBtn"
                                >
                                  Next
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {/* <button onClick={() => setSelectValue("section7")}>
                    Select Section 7
                  </button> */}
                  {/* <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(8)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 8 ? (
                <>
                  
                    <>
                      <h1 className="text-black p-4 !capitalize">
                        Save your project
                      </h1>
  
                      <div className="flex flex-col justify-center mb-8">
                        <div className="flex flex-col justify-center w-full mx-auto">
                          <img
                            src={BOOK_}
                            alt="BOOK_"
                            className="w-2/5 mx-auto"
                          />
                        </div>
                        <div>
                          <h1 className="text-center text-2xl text-black">
                            Lock in your price now by saving your quote.
                          </h1>
                        </div>
                        <div>
                          <p className="text-center text-black my-3">
                            Doing so will allow us to email your quote details
                            right away.
                          </p>
                        </div>
                        <div className="flex justify-center my-3 w-2/4 mx-auto">
                          <input
                            type="email"
                            name="section8"
                            onChange={onSectionEight}
                            className="border-[1px] border-solid border-gray-500 rounded-sm p-2 w-full"
                            required
                          />
                        </div>
                      </div>
                      <div class="row m-0 w-full">
                        <div class="col-md-12 p-0">
                          <div class="form-button-step">
                            <button
                              type="button"
                              // onClick={() => getLiData(4)}
                              onClick={() => getLiData(7)}
                              class="btn themeBtn"
                            >
                              Previous
                            </button>
                            {selectValue.section8 == null ? (
                              <button
                                type="button"
                                onClick={handleClick}
                                // onClick={() => getLiData(2)}
                                className={
                                  isClicked
                                    ? "jerk-button btn themeBtn opacity-35"
                                    : "btn themeBtn opacity-35"
                                }
                              >
                                Save Project
                              </button>
                            ) : (
                              <button
                                type="button"
                                disabled={selectValue.section8 == null}
                                onClick={() => onOpenModal("success")}
                                class="btn themeBtn"
                              >
                                Save Project
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  
  
                  {/* <button onClick={() => setSelectValue("section8")}>
                    Select Section 8
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(9)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : (
                <>
                  <button onClick={() => setSelectValue("section9")}>
                    Select Section 9
                  </button>
              
                </>
              )

            ): (
              liData == 1 ? (
                <>
                  <div class="tab-pane fade show active" id="stepNew1">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need book distribution?</h2>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input !text-[#c65300]"
                                    type="radio"
                                    checked={selectValue.section1 === "399"}
                                    onChange={onChangeAllValue}
                                    name="section1"
                                    value="399"
                                    id="first-check-one"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-one"
                                  >
                                    Printed on Demand (Global Retailers) ($399)
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input !text-[#c65300]"
                                    onChange={onChangeAllValue}
                                    checked={selectValue.section1 === "149"}
                                    type="radio"
                                    name="section1"
                                    id="first-check-two"
                                    value="149"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-two"
                                  >
                                    Print On Demand (Bookshop™ Only) ($149)
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input !text-[#c65300]"
                                    onChange={onChangeAllValue}
                                    checked={selectValue.section1 === "0"}
                                    type="radio"
                                    id="first-check-Three"
                                    name="section1"
                                    value="0"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-Three"
                                  >
                                    I don't need printed book distribution
                                  </label>
                                </div>
                              </div>
                            </div>
  
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                <figure className="flex flex-col justify-center items-center">
                                  <img src={BBP_POD} class="img-fluid" alt="" />
                                </figure>
                                <p>
                                  Make your book available for sale with the
                                  largest network of global booksellers,
                                  libraries, and online retailers. Includes
                                  distribution to Amazon, Powell’s, Barnes &
                                  Noble, Ingram, Baker & Taylor, and 50+ others.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  // class="btn themeBtn"
                                  // disabled
                                  onClick={handleClickFunc}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      prevClicked
                                        ? "jerk-button btn themeBtn"
                                        : "btn themeBtn"
                                    }
                                >
                                  Previous
                                </button>
                                {selectValue.section1 == null ? (
                                  <button
                                    type="button"
                                    // class="btn themeBtn"
                                    // disabled={selectValue.section1 == null}
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    class="btn themeBtn"
                                    disabled={selectValue.section1 == null}
                                    onClick={() => getLiData(2)}
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section1")}>
              Select Section One
            </button> */}
                  {/* <button
              disabled={selectValue == ""}
              onClick={() => getLiData(2)}
              className="bg-black text-white"
            >
              Next
            </button> */}
                </>
              ) : liData == 2 ? (
                <>
                  <div class="tab-pane fade" id="stepNew2">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need text formatting?</h2>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    value="100"
                                    name="section2"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "100"}
                                    id="second-check-one"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="second-check-one"
                                  >
                                    I need text formatting
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    value="200"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "200"}
                                    id="second-check-two"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for={"second-check-two"}
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
  
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "300"}
                                    value="300"
                                    id="second-check-three"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for={"second-check-three"}
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
  
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    value="400"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "400"}
                                    id="second-check-four"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="second-check-four"
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
  
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="section2"
                                    value="500"
                                    onChange={onSectionTwo}
                                    checked={selectValue.section2 == "500"}
                                    id="second-check-five"
                                    //  onChange={(e) => onChangeAllValue("section2", e.target.value)}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="second-check-five"
                                  >
                                    I didn't need text formatting
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex justify-center flex-col items-center">
                                <figure class="flex justify-center flex-col items-center">
                                  <img
                                    src={BBP_POD}
                                    class="img-fluid !w-4/5"
                                    alt=""
                                  />
                                </figure>
                                <p>
                                  Make your book available for sale with the
                                  largest network of global booksellers,
                                  libraries, and online retailers. Includes
                                  distribution to Amazon, Powell’s, Barnes &
                                  Noble, Ingram, Baker & Taylor, and 50+ others.
                                </p>
                              </div>
                            </div>
                          </div>
  
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(1)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section2 == null ? (
                                  <button
                                    type="button"
                                    // disabled={selectValue.section2 == null}
                                    // class="btn themeBtn"
                                    onClick={handleClick}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section2 == null}
                                    onClick={() => getLiData(3)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section2")}>
                    Select Section Two
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(3)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 3 ? (
                <>
                  <div class="tab-pane fade" id="stepNew3">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need cover design?</h2>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input "
                                    type="radio"
                                    id="first-check-three-one"
                                    value="599"
                                    onChange={onSectionThree}
                                    checked={selectValue.section3 == "599"}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-three-one"
                                  >
                                    Professional Cover Design ($599)
                                  </label>
                                </div>
                                <div class="form-check p-2">
                                  <input
                                    class="form-check-input "
                                    type="radio"
                                    id="first-check-three-Two"
                                    value="50"
                                    onChange={onSectionThree}
                                    checked={selectValue.section3 == "50"}
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-three-Two"
                                  >
                                    I am supplying my cover design
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont  flex justify-center flex-col items-center">
                                <figure className=" flex justify-center items-center">
                                  <img src={BBP_POD} class="img-fluid" alt="" />
                                </figure>
                                <p>
                                  Make your book available for sale with the
                                  largest network of global booksellers,
                                  libraries, and online retailers. Includes
                                  distribution to Amazon, Powell’s, Barnes &
                                  Noble, Ingram, Baker & Taylor, and 50+ others.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(2)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section3 == null ? (
                                  <button
                                    type="button"
                                    // disabled={selectValue.section3 == null}
                                    // onClick={() => getLiData(4)}
                                    // class="btn themeBtn"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section3 == null}
                                    onClick={() => getLiData(4)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section3")}>
                    Select Section 3
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(4)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 4 ? (
                <>
                  <div class="tab-pane fade" id="stepNew4">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between items-center w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>Do you need an ISBN?</h2>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-four-one"
                                    name="section4"
                                    onChange={onSectionFour}
                                    checked={selectValue.section4 == "49"}
                                    value="49"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-four-one"
                                  >
                                    I need to purchase an ISBN number ($49)
                                  </label>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-four-Two"
                                    name="section4"
                                    onChange={onSectionFour}
                                    checked={selectValue.section4 == "99"}
                                    value="99"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-four-Two"
                                  >
                                    I already have an ISBN for my book
                                  </label>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input "
                                    type="radio"
                                    id="first-check-four-three"
                                    name="section4"
                                    onChange={onSectionFour}
                                    checked={selectValue.section4 == "149"}
                                    value="149"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="first-check-four-three"
                                  >
                                    I don't need an ISBN number
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <figure className="flex justify-center items-center">
                                  <img src={BBP_POD_1} class="img-fluid" alt="" />
                                </figure>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(3)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section4 == null ? (
                                  <button
                                    type="button"
                                    // disabled={selectValue.section4 == null}
                                    // onClick={() => getLiData(5)}
                                    // class="btn themeBtn"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section4 == null}
                                    onClick={() => getLiData(5)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section4")}>
                    Select Section 4
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(5)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 5 ? (
                <>
                  <div class="tab-pane fade" id="stepNew5">
                    <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between items-center w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>
                                  Do you need extra book promotion? (Choose
                                  Multiple)
                                </h2>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-five-one"
                                    name="section5"
                                    onChange={onSectionFive}
                                    checked={selectValue.section5 == "49"}
                                    value="49"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-five-one"
                                    >
                                      I need to purchase an ISBN number ($49)
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-five-Two"
                                    // value="option2"
                                    name="section5"
                                    onChange={onSectionFive}
                                    checked={selectValue.section5 == "999"}
                                    value="999"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-five-Two"
                                    >
                                      I already have an ISBN for my book
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-five-three"
                                    // value="option2"
                                    name="section5"
                                    onChange={onSectionFive}
                                    checked={selectValue.section5 == "10"}
                                    value="10"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-five-three"
                                    >
                                      I don't need an ISBN number
                                    </label>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                <figure className="flex justify-center items-center">
                                  <img src={PTR200} class="img-fluid" alt="" />
                                </figure>
                                <p>
                                  Get the most out of each meet and greet,
                                  speaking engagement, or writer's conference by
                                  using personalized bookmarks and printed
                                  posters—customized with artwork from your book.
                                  11"x17" posters starting at just $49 for 50.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0 w-full">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(4)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                {selectValue.section5 == null ? (
                                  <button
                                    type="button"
                                    onClick={handleClick}
                                    // onClick={() => getLiData(2)}
                                    className={
                                      isClicked
                                        ? "jerk-button btn themeBtn opacity-35"
                                        : "btn themeBtn opacity-35"
                                    }
                                  >
                                    Next
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={selectValue.section5 == null}
                                    onClick={() => getLiData(6)}
                                    class="btn themeBtn"
                                  >
                                    Next
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
  
                  {/* <button onClick={() => setSelectValue("section5")}>
                    Select Section 5
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(6)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 6 ? (
                <>
                  <div class="tab-pane fade" id="stepNew6">
                    {sidebarLink == "ebookDistribution" ? (
                      <form id="stepForm">
                        <div class="Cal-Form-one">
                          <div class="container p-0">
                            <div class="row flex justify-between items-center w-full">
                              <div class="col-md-6 w-full">
                                <div class="Cal-Form-one-cont">
                                  <h2>Do you need extra book promotion?</h2>
                                  <div class="form-check px-2">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="first-check-six-one"
                                      name="section6"
                                      onChange={onSectionSix}
                                      checked={selectValue.section6 == "49"}
                                      value="49"
                                    />
                                    <button
                                      type="button"
                                      class="btn"
                                      data-toggle="modal"
                                      data-target="#quantityModal"
                                    >
                                      <label
                                        class="form-check-label"
                                        for="first-check-six-one"
                                      >
                                        I need to purchase an ISBN number ($49)
                                      </label>
                                    </button>
                                  </div>
                                  <div class="form-check px-2">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      id="first-check-Six-Two"
                                      // value="option2"
                                      name="section6"
                                      onChange={onSectionSix}
                                      checked={selectValue.section6 == "499"}
                                      value="499"
                                    />
                                    <button
                                      type="button"
                                      class="btn"
                                      data-toggle="modal"
                                      data-target="#quantityModal"
                                    >
                                      <label
                                        class="form-check-label"
                                        for="first-check-Six-Two"
                                      >
                                        I already have an ISBN for my book
                                      </label>
                                    </button>
                                  </div>
                                  {/* <div class="form-check px-2">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="first-check-Six-three"
                      // value="option2"
                      name="section6"
                      onChange={onSectionSix}
                      checked={selectValue.section6 == "10"}
                      value="10"
                    />
                    <button
                      type="button"
                      class="btn"
                      data-toggle="modal"
                      data-target="#quantityModal"
                    >
                      <label
                        class="form-check-label"
                        for="first-check-Six-three"
                      >
                        I don't need an ISBN number
                      </label>
                    </button>
                  </div> */}
                                </div>
                              </div>
                              <div class="col-md-6 w-full">
                                <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                  <figure className="flex justify-center items-center">
                                    <img src={PTR200} class="img-fluid" alt="" />
                                  </figure>
                                  <p>
                                    Get the most out of each meet and greet,
                                    speaking engagement, or writer's conference by
                                    using personalized bookmarks and printed
                                    posters—customized with artwork from your
                                    book. 11"x17" posters starting at just $49 for
                                    50.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="row m-0 w-full">
                              <div class="col-md-12 p-0">
                                <div class="form-button-step">
                                  <button
                                    type="button"
                                    onClick={() => getLiData(5)}
                                    class="btn themeBtn"
                                  >
                                    Previous
                                  </button>
                                  {selectValue.section6 == null ? (
                                    <button
                                      type="button"
                                      onClick={handleClick}
                                      // onClick={() => getLiData(2)}
                                      className={
                                        isClicked
                                          ? "jerk-button btn themeBtn opacity-35"
                                          : "btn themeBtn opacity-35"
                                      }
                                    >
                                      Next
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      disabled={selectValue.section6 == null}
                                      onClick={() => getLiData(7)}
                                      class="btn themeBtn"
                                    >
                                      Next
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <>
                        <h1 className="text-black p-4 !capitalize">
                          Save your project
                        </h1>
  
                        <div className="flex flex-col justify-center mb-8">
                          <div className="flex flex-col justify-center w-full mx-auto">
                            <img
                              src={BOOK_}
                              alt="BOOK_"
                              className="w-2/5 mx-auto"
                            />
                          </div>
                          <div>
                            <h1 className="text-center text-2xl text-black">
                              Lock in your price now by saving your quote.
                            </h1>
                          </div>
                          <div>
                            <p className="text-center text-black my-3">
                              Doing so will allow us to email your quote details
                              right away.
                            </p>
                          </div>
                          <div className="flex justify-center my-3 w-2/4 mx-auto">
                            <input
                              type="email"
                              name="section6"
                              onChange={onSectionSix}
                              className="border-[1px] border-solid border-gray-500 rounded-sm p-2 w-full"
                              required
                            />
                          </div>
                        </div>
                        <div class="row m-0 w-full">
                          <div class="col-md-12 p-0">
                            <div class="form-button-step">
                              <button
                                type="button"
                                // onClick={() => getLiData(4)}
                                onClick={() => getLiData(5)}
                                class="btn themeBtn"
                              >
                                Previous
                              </button>
                              <button
                                type="button"
                                disabled={selectValue.section6 == null}
                                onClick={() => onOpenModal("success")}
                                class="btn themeBtn"
                              >
                                Save Project
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {/* <form id="stepForm">
                      <div class="Cal-Form-one">
                        <div class="container p-0">
                          <div class="row flex justify-between items-center w-full">
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont">
                                <h2>
                                  Do you need extra book promotion? (Choose
                                  Multiple)
                                </h2>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-six-one"
                                  
                                    name="section6"
                                    onChange={onSectionSix}
                                    checked={selectValue.section6 == "49"}
                                    value="49"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-Six-one"
                                    >
                                      I need to purchase an ISBN number ($49)
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-Six-Two"
                                    // value="option2"
                                    name="section6"
                                    onChange={onSectionSix}
                                    checked={selectValue.section6 == "499"}
                                    value="499"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-Six-Two"
                                    >
                                      I already have an ISBN for my book
                                    </label>
                                  </button>
                                </div>
                                <div class="form-check px-2">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    id="first-check-Six-three"
                                    // value="option2"
                                    name="section6"
                                    onChange={onSectionSix}
                                    checked={selectValue.section6 == "10"}
                                    value="10"
                                  />
                                  <button
                                    type="button"
                                    class="btn"
                                    data-toggle="modal"
                                    data-target="#quantityModal"
                                  >
                                    <label
                                      class="form-check-label"
                                      for="first-check-Six-three"
                                    >
                                      I don't need an ISBN number
                                    </label>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 w-full">
                              <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                                <figure className="flex justify-center items-center">
                                  <img
                                    src={PTR200}
                                    class="img-fluid"
                                    alt=""
                                  />
                                </figure>
                                <p>
                                  Get the most out of each meet and greet,
                                  speaking engagement, or writer's conference by
                                  using personalized bookmarks and printed
                                  posters—customized with artwork from your book.
                                  11"x17" posters starting at just $49 for 50.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="row m-0 w-full">
                            <div class="col-md-12 p-0">
                              <div class="form-button-step">
                                <button
                                  type="button"
                                  onClick={() => getLiData(5)}
                                  class="btn themeBtn"
                                >
                                  Previous
                                </button>
                                <button
                                  type="button"
                                  disabled={selectValue.section6 == ""}
                                  onClick={() => getLiData(7)}
                                  class="btn themeBtn"
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form> */}
                  </div>
                  {/* <button onClick={() => setSelectValue("section6")}>
                    Select Section 6
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(7)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 7 ? (
                <>
                  <form id="stepForm">
                    <div class="Cal-Form-one">
                      <div class="container p-0">
                        <div class="row flex justify-between items-center w-full">
                          <div class="col-md-6 w-full">
                            <div class="Cal-Form-one-cont">
                              <h2>Do you need extra book promotion?</h2>
                              <div class="form-check px-2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  id="first-check-seven-one"
                                  name="section7"
                                  onChange={onSectionSeven}
                                  checked={selectValue.section7 == "49"}
                                  value="49"
                                />
                                <button
                                  type="button"
                                  class="btn"
                                  data-toggle="modal"
                                  data-target="#quantityModal"
                                >
                                  <label
                                    class="form-check-label"
                                    for="first-check-seven-one"
                                  >
                                    I need to purchase an ISBN number ($49)
                                  </label>
                                </button>
                              </div>
                              <div class="form-check px-2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  id="first-check-seven-Two"
                                  // value="option2"
                                  name="section7"
                                  onChange={onSectionSeven}
                                  checked={selectValue.section7 == "499"}
                                  value="499"
                                />
                                <button
                                  type="button"
                                  class="btn"
                                  data-toggle="modal"
                                  data-target="#quantityModal"
                                >
                                  <label
                                    class="form-check-label"
                                    for="first-check-seven-Two"
                                  >
                                    I already have an ISBN for my book
                                  </label>
                                </button>
                              </div>
                              <div class="form-check px-2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  id="first-check-seven-three"
                                  // value="option2"
                                  name="section7"
                                  onChange={onSectionSeven}
                                  checked={selectValue.section7 == "10"}
                                  value="10"
                                />
                                <button
                                  type="button"
                                  class="btn"
                                  data-toggle="modal"
                                  data-target="#quantityModal"
                                >
                                  <label
                                    class="form-check-label"
                                    for="first-check-seven-three"
                                  >
                                    I don't need an ISBN number
                                  </label>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 w-full">
                            <div class="Cal-Form-one-cont flex flex-col justify-center items-center">
                              <figure className="flex justify-center items-center">
                                <img src={PTR200} class="img-fluid" alt="" />
                              </figure>
                              <p>
                                Get the most out of each meet and greet, speaking
                                engagement, or writer's conference by using
                                personalized bookmarks and printed
                                posters—customized with artwork from your book.
                                11"x17" posters starting at just $49 for 50.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="row m-0 w-full">
                          <div class="col-md-12 p-0">
                            <div class="form-button-step">
                              <button
                                type="button"
                                onClick={() => getLiData(6)}
                                class="btn themeBtn"
                              >
                                Previous
                              </button>
                              {selectValue.section7 == null ? (
                                <button
                                  type="button"
                                  onClick={handleClick}
                                  // onClick={() => getLiData(2)}
                                  className={
                                    isClicked
                                      ? "jerk-button btn themeBtn opacity-35"
                                      : "btn themeBtn opacity-35"
                                  }
                                >
                                  Next
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  disabled={selectValue.section7 == null}
                                  onClick={() => getLiData(8)}
                                  class="btn themeBtn"
                                >
                                  Next
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {/* <button onClick={() => setSelectValue("section7")}>
                    Select Section 7
                  </button> */}
                  {/* <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(8)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : liData == 8 ? (
                <>
                  {sidebarLink == "ebookDistribution" ? (
                    <>
                      <h1 className="text-black p-4 !capitalize">
                        Save your project
                      </h1>
  
                      <div className="flex flex-col justify-center mb-8">
                        <div className="flex flex-col justify-center w-full mx-auto">
                          <img
                            src={BOOK_}
                            alt="BOOK_"
                            className="w-2/5 mx-auto"
                          />
                        </div>
                        <div>
                          <h1 className="text-center text-2xl text-black">
                            Lock in your price now by saving your quote.
                          </h1>
                        </div>
                        <div>
                          <p className="text-center text-black my-3">
                            Doing so will allow us to email your quote details
                            right away.
                          </p>
                        </div>
                        <div className="flex justify-center my-3 w-2/4 mx-auto">
                          <input
                            type="email"
                            name="section8"
                            onChange={onSectionEight}
                            className="border-[1px] border-solid border-gray-500 rounded-sm p-2 w-full"
                            required
                          />
                        </div>
                      </div>
                      <div class="row m-0 w-full">
                        <div class="col-md-12 p-0">
                          <div class="form-button-step">
                            <button
                              type="button"
                              // onClick={() => getLiData(4)}
                              onClick={() => getLiData(7)}
                              class="btn themeBtn"
                            >
                              Previous
                            </button>
                            {selectValue.section8 == null ? (
                              <button
                                type="button"
                                onClick={handleClick}
                                // onClick={() => getLiData(2)}
                                className={
                                  isClicked
                                    ? "jerk-button btn themeBtn opacity-35"
                                    : "btn themeBtn opacity-35"
                                }
                              >
                                Save Project
                              </button>
                            ) : (
                              <button
                                type="button"
                                disabled={selectValue.section8 == null}
                                onClick={() => onOpenModal("success")}
                                class="btn themeBtn"
                              >
                                Save Project
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
  
                  {/* <button onClick={() => setSelectValue("section8")}>
                    Select Section 8
                  </button>
                  <button
                    disabled={selectValue == ""}
                    onClick={() => getLiData(9)}
                    className="bg-black text-white"
                  >
                    Next
                  </button> */}
                </>
              ) : (
                <>
                  <button onClick={() => setSelectValue("section9")}>
                    Select Section 9
                  </button>
              
                </>
              )
            )}
            
          </div>
        </div>
      </div>
    </div>
  );
};
